import { render, staticRenderFns } from "./LightingYOM.vue?vue&type=template&id=2f7d8d76&scoped=true"
import script from "./LightingYOM.vue?vue&type=script&lang=js"
export * from "./LightingYOM.vue?vue&type=script&lang=js"
import style0 from "./LightingYOM.vue?vue&type=style&index=0&id=2f7d8d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d8d76",
  null
  
)

export default component.exports